import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component';
import { ApiService, UserInfo } from 'app/services/api.service'
import { Feedback } from 'app/interfaces/feedback.interface';
import { AnalyticsService } from 'app/services/analytics.service';


@Component({
  selector: 'app-footer-fabricator-rewards',
  templateUrl: './footer-fabricator-rewards.component.html',
  styleUrl: './footer-fabricator-rewards.component.scss',
  standalone: true,
  imports: [ CommonModule, TranslateModule, CosentinoSvgComponent, ButtonComponent ]
})
export class FooterFabricatorRewardsComponent implements OnInit {
  @Input() telefono: string = '';
  @Input() email: string = '';
  @Input() comentario: string = '';
  @Input() valoracion: number = 0;
  
  @Output() comentarioChange = new EventEmitter<string>();
  @Output() valoracionChange = new EventEmitter<number>();
  @Output() enviarValoracion = new EventEmitter<Feedback>();

  
  isSubmitting: boolean = false;
  hoverValoracion: number = 0;
  userInfo: UserInfo;
  feedback: Feedback = {
    type: "Rewards Fabricator",
    limitValoration: 5
  };

  constructor(private api: ApiService, private analytics: AnalyticsService) {}
  
  ngOnInit(): void {
    this.api.userInfo.subscribe( (userInfo) => { this.userInfo = userInfo });
    this.isSubmitting = false;
  }

  onComentarioInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement;
    this.comentarioChange.emit(target.value);
  }

  setValoracion(valor: number): void {
    //console.log(valor);
    this.valoracionChange.emit(valor);
  }

  setHover(valor: number): void {
    this.hoverValoracion = valor;
  }

  clearHover(): void {
    this.hoverValoracion = 0;
  }

  submit(): void {
    if (this.valoracion > 0) {
      this.analytics.trackClick('submit-rating', undefined, {
        click_type: 'review',
        type: this.valoracion.toString()
      });

      this.feedback.comment = this.comentario;
      this.feedback.valoration = this.valoracion;
      this.isSubmitting = true; 

      this.api.myFeedback__create(this.feedback)
        .subscribe({ next: (feedback) => {
          this.feedback  = feedback;
        }, error: (err) => {
          console.error(err);
          this.isSubmitting = false;
        }
      });
    }
  }
}

